import React, { useEffect, useRef, useState } from 'react';
import { IconButton } from '@material-ui/core';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import { useStyles } from './SortableColumn.styles';
import TooltipOne from '../TooltipOne/TooltipOne.component';

interface SortableColumnProps<T> {
  id: T;
  isActiveSorting: boolean;
  columnName: string;
  isDescending: boolean;
  tabIndex?: number;
  setSortByColumn: (columnId: T) => void;
  setIsDescending: (isAscending: boolean) => void;
}

export const SortableColumn = <T,>({
  id,
  columnName,
  isDescending,
  tabIndex,
  setSortByColumn,
  isActiveSorting,
  setIsDescending,
}: SortableColumnProps<T>): JSX.Element => {
  const styles = useStyles();

  const [isVisible, setIsVisible] = useState<boolean>(false);
  const handleOnClick = () => {
    setSortByColumn(id);
    setIsDescending(!isDescending);
  };

  useEffect(() => {
    setIsVisible(isActiveSorting);
  }, [isActiveSorting]);

  return (
    <span
      className={styles.container}
      onMouseEnter={() => {
        if (!isVisible && !isActiveSorting) setIsVisible(true);
      }}
      onMouseLeave={() => {
        if (isVisible && !isActiveSorting) setIsVisible(false);
      }}
      onBlur={() => {
        if (!isActiveSorting) setIsVisible(false);
      }}
      onFocus={() => {
        setIsVisible(true);
      }}
    >
      {columnName}
      <div style={{ width: '25px' }}>
        {
          <TooltipOne title={`Sortowanie jest ${isDescending ? 'malejące' : 'rosnące'}`} placement="top">
            <IconButton
              disableRipple
              onClick={handleOnClick}
              size="small"
              className={styles.button}
              aria-label={`sortowanie ${isDescending ? 'malejąco' : 'rosnąco'} według kolumny ${columnName}`}
              tabIndex={isVisible ? -1 : tabIndex}
            >
              {isVisible && (
                <>
                  {isDescending ? (
                    <ArrowDownwardIcon className={styles.icon} tabIndex={tabIndex} />
                  ) : (
                    <ArrowUpwardIcon className={styles.icon} tabIndex={tabIndex} />
                  )}
                </>
              )}
            </IconButton>
          </TooltipOne>
        }
      </div>
    </span>
  );
};
